import { freeze } from 'utils/dom'

import { normalizeUserParam } from './normalize'

// import { REQUIREMENTS } from 'app/Auth/Password/lib'

export const R_USER = {
  SET: Symbol('R_USER:SET'),
  SET_TAGS: Symbol('R_USER:SET_TAGS'),
  MERGE: Symbol('R_USER:MERGE'),
  SAVER: Symbol('R_USER:SAVER'),
  UPSERT_FILE: Symbol('R_USER:UPSERT_FILE'),
  DELETE_FILE: Symbol('R_USER:DELETE_FILE'),
  NEW_AVATAR: Symbol('R_USER:NEW_AVATAR')
}

export const CHECK_JUNK_MAIL = `
If it does not appear soon, please check your Junk Mail folder.
`

export function defaultUser() {
  return freeze({
    id: '',
    settings: {},
    handle: '',
    name: '',
    verified: false,
    emails: [],
    data: [],
    factors: [],
    ...normalizeUserParam('data', []),
    ...normalizeUserParam('emails', []), // do we even query?
    authStatus: 'unknown',
    access_token: undefined,
    access_token_expires: 0,
    validation_token: undefined,
    can: () => false,
    canAny: () => false,
    is: () => false,
    isAny: () => false,
    allows: () => false,
    age: 0,
    isIdentified: false,
    isAuthN: false,
    createdAgo: '',
    avatar: { default: true },
    subscriptions: []
  })
}
